import React from "react";
import ReactDOM from "react-dom";

const App = () => <div>Hello world!</div>;

ReactDOM.render(React.createElement(App), document.getElementById("root"));
